import PublishedProfileActions from './PublishedProfileActions.component';

export default PublishedProfileActions;
